"use client";

import { useEffect } from "react";
import moengage from "@moengage/web-sdk";
let moengageInstance = null;

export const initMoengage = () => {
  if (
    typeof window !== "undefined" &&
    !moengageInstance
  ) {

    const hostname = window?.location?.hostname;
    const isLocalhost = hostname === "localhost" || hostname === "127.0.0.1";
    
    
    // Skip only on localhost
    if (isLocalhost) {
      console.log("[MoEngage] Skipping initialization on localhost");
      return;
    }

    // Initialize MoEngage with your App ID
    moengageInstance = moengage.initialize({
      app_id: `${process.env.NEXT_PUBLIC_MOENGAGE_KEY}`, // Replace with your MoEngage App ID
      debug_logs: process.env.NEXT_PUBLIC_MOENGAGE_LOG, // 1=Test| 0 = Live, Enable logs in development , can be disabled in production
      useLatest: true,
      cluster: "DC_3",
      swPath: "/serviceworker.js",
      enableSPA: true,
    });
  }
};

export const MoengageProvider = () => {
  useEffect(() => {
    initMoengage();
  }, []);
  return null;
};

export const setMoEngageUserAttributes = (attrs = {}) => {
  if (!attrs || typeof attrs !== "object") {
    console.warn("[MoEngage] Attributes must be a non-null object", attrs);
    return;
  }
  Object.entries(attrs).forEach(([key, value]) => {
    moengage.add_user_attribute(key, value ?? "");
  });
};
